import React from 'react'
import { List as MList, ListProps as MListProps } from '@mantine/core'
import { createStyles } from '@mantine/styles'

const useStyles = createStyles((theme, _params) => {
  return {
    custom: {},

    basic: {},

    light: {
      color: theme.colors.brandDarkGray[4],
    },
  }
})

export type ListProps = MListProps & {
  styleType?: 'custom' | 'basic' | 'light'
}

export function List({ styleType = 'basic', children, ...props }: ListProps) {
  const { classes } = useStyles()

  return (
    <MList className={classes[styleType]} {...props}>
      {children}
    </MList>
  )
}
